var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"variant":"white","spinner-variant":"primary","blur":"0","opacity":".75","rounded":"sm","show":_vm.isLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }